import { Injectable } from '@angular/core';
import { GlobalVariable } from '.././config/service.config';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MantenedorService {

  url = GlobalVariable.BASE_API_URL;
  headersc = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json');
  constructor(private http: HttpClient) { }

  public Institucion() {
    return this.http.post(`${this.url}mantenedor/institucion`, null, { headers: this.headersc });
  }
  getSede(id) {
    return this.http.post(`${this.url}mantenedor/sede/?idInstitucion=${id}`, null, { headers: this.headersc });
  }
  getArea(id) {
    return this.http.post(`${this.url}mantenedor/area/?idInstitucion=${id}`, null, { headers: this.headersc });
  }
  getCarrera(id) {
    return this.http.post(`${this.url}mantenedor/carrera/?idArea=${id}`, null, { headers: this.headersc });
  }
  getComuna(id) {
    return this.http.post(`${this.url}mantenedor/comuna/?idRegion=${id}`, null, { headers: this.headersc });
  }
  getCiudad(id) {
    return this.http.post(`${this.url}mantenedor/ciudad/?idRegion=${id}`, null, { headers: this.headersc });
  }
  getestablecimientoeducacionl(id) {
    return this.http.post(`${this.url}mantenedor/establecimientoeducacionl/?idRegion=${id}`, null, { headers: this.headersc });
  }
  getRegion() {
    return this.http.post(`${this.url}mantenedor/region`, null, { headers: this.headersc });
  }
  getPais() {
    return this.http.post(`${this.url}mantenedor/pais`, null, { headers: this.headersc });
  }
  getAnhoEgreso():Observable<any> {
    return this.http.post(`${this.url}mantenedor/anhoegreso`, null, { headers: this.headersc });
  }

  public getInstitucion2(idPeriodo: string) {
    let httpParams = new HttpParams()
      .set('idPeriodo', idPeriodo)
    return this.http.post(`${this.url}mantenedor/institucion2`, null, { headers: this.headersc, params: httpParams });
  }

  public getSede2(idPeriodo: string, idInstitucion: string) {
    debugger;
    let httpParams = new HttpParams()
      .set('idPeriodo', idPeriodo)
      .set('idInstitucion', idInstitucion)
    return this.http.post(`${this.url}mantenedor/sede2`, null, { headers: this.headersc, params: httpParams });
  }

  public getArea2(idPeriodo: string, idInstitucion: string, idSede: string) {
    let httpParams = new HttpParams()
      .set('idPeriodo', idPeriodo)
      .set('idInstitucion', idInstitucion)
      .set('idSede', idSede)
    return this.http.post(`${this.url}mantenedor/area2`, null, { headers: this.headersc, params: httpParams });
  }

  public getCarrera2(idPeriodo: string, idInstitucion: string, idSede: string, idArea: string, jornada: string, tipoprograma: string) {
    let httpParams = new HttpParams()
      .set('idPeriodo', idPeriodo)
      .set('idInstitucion', idInstitucion)
      .set('idSede', idSede)
      .set('idArea', idArea)
      .set('jornada', jornada)
      .set('tipoprograma', tipoprograma)
    return this.http.post(`${this.url}mantenedor/carrera2`, null, { headers: this.headersc, params: httpParams });
  }
}

